import type { Gradient } from '@jouzen/ecom-components';

const CLASS_NAME = 'hidden lg:block';

export const membershipGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#DCCFBB',
    id: 'orange-1',
    position: [10, 5],
    opacity: 0.7,
    size: 20,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D8A78C',
    id: 'orange-2',
    position: [90, 18],
    opacity: 0.4,
    size: 13,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D4D9DD',
    id: 'blue-2',
    position: [87, 39],
    opacity: 1,
    size: 15,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D4D9DD',
    id: 'blue-3',
    position: [10, 30],
    opacity: 1,
    size: 20,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#CED4B8',
    id: 'sage-1',
    position: [10, 52],
    opacity: 0.5,
    size: 15,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#CED4B8',
    id: 'sage-2',
    position: [87, 59],
    opacity: 0.5,
    size: 20,
    className: CLASS_NAME,
  },
];
